import { Http } from '@/lib/http';

export class SourceOfIncomeService extends Http {
  endpoint = 'onboarder/settings/source-of-income-types';

  constructor() {
    super();
  }

  fetchSourceOfIncomeTypes() {
    return this.httpClient().get(this.endpoint);
  }

  fetchPaginatedSourceOfIncomeTypes(params) {
    return this.httpClient().get(`${this.endpoint}/paginated`, { params });
  }

  updateSourceOfIncomeTypes({ id, updates }) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  createSourceOfIncomeType(incomeType) {
    return this.httpClient().post(this.endpoint, incomeType);
  }

  deleteSourceOfIncomeType(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }
}